module.exports = __webpack_public_path__ + "static/media/logo-greyf8.2c3662b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-greyf8.svg
// module id = 1121
// module chunks = 0